import { required } from "vuelidate/lib/validators";

export default class FaturamentoData {
  forma_pagamento = null;
  valor = null;
  vencimento = null;
  subtotal = 0;
  pagamentos = [];
  dia_cobranca = 5;
  dia_envio_fatura = 1;
  id_plano_contas = null;
  taxa_implantacao = 0;
  cobranca_anual = false;
  considerar_taxa = false;
  data_boleto_taxa = null;
  gerar_boleto_taxa = true;
  pular_final_semana = false;
  plugin_tef = false;
  plugin_certificado = false;
  valor_tef = 0;
  valor_certificado = 0;
  constructor(
    forma_pagamento = null,
    valor = 0,
    vencimento = null,
    subtotal = 0,
    pagamentos = [],
    dia_cobranca = 5,
    dia_envio_fatura = 1,
    id_plano_contas = null,
    taxa_implantacao = 0,
    cobranca_anual = false,
    considerar_taxa = false,
    data_boleto_taxa = null,
    gerar_boleto_taxa = true,
    pular_final_semana = false,
    plugin_tef = false,
    plugin_certificado = false,
    valor_tef = 0,
    valor_certificado = 0,
  ) {
    this.forma_pagamento = forma_pagamento;
    this.valor = valor;
    this.vencimento = vencimento;
    this.subtotal = subtotal;
    this.pagamentos = pagamentos;
    this.dia_cobranca = dia_cobranca;
    this.dia_envio_fatura = dia_envio_fatura;
    this.id_plano_contas = id_plano_contas;
    this.taxa_implantacao = taxa_implantacao;
    this.considerar_taxa = considerar_taxa;
    this.data_boleto_taxa = data_boleto_taxa;
    this.gerar_boleto_taxa = gerar_boleto_taxa;
    this.pular_final_semana = pular_final_semana;
    this.plugin_tef = plugin_tef;
    this.plugin_certificado = plugin_certificado;
    this.valor_tef = valor_tef;
    this.valor_certificado = valor_certificado;
  }
}

export const FaturamentoDataRequired = {};
